import React from "react";
import styled from 'styled-components'
// reactstrap components
import {
  Container,
  Row,
  Media
} from "reactstrap";

import IndexNavbar from "components/Navbars/IndexNavbar.js";
import DemoFooter from "components/Footers/DemoFooter.js";
import LogisticsBackground from 'assets/img/logistics123.png';

import truck1 from 'assets/img/trucks/truck1.jpg'
import truck2 from 'assets/img/trucks/truck2.jpg'
import truck3 from 'assets/img/trucks/truck3.jpeg'
import truck4 from 'assets/img/trucks/truck4.jpg'
import truck5 from 'assets/img/trucks/truck5.jpg'
import truck6 from 'assets/img/trucks/truck6.jpg'
import truck7 from 'assets/img/trucks/truck7.jpg'
import truck8 from 'assets/img/trucks/truck8.jpg'
import truck9 from 'assets/img/trucks/truck9.jpg'
import truck10 from 'assets/img/trucks/truck10.jpg'
import truck11 from 'assets/img/trucks/truck11.jpg'
import truck12 from 'assets/img/trucks/truck12.jpeg'
import { useTranslation } from 'react-i18next';

const MainText = styled.h3`
`

const BackImage = styled.img`
  height: 600px;
  width: 100%;
`
const TrucksImage = styled.img`
    width: 200px;
    height: 100%;
    border-radius: 8px;
    margin-right: 20px;
`
const MediaStyled = styled(Media)`
    margin-top: -10px;
`
function ProfilePage() {
    const { t } = useTranslation()
  return (
    <>
      <IndexNavbar />
      <BackImage src={LogisticsBackground} alt='logistics'/>
      <Container>
      <Row>
        <MainText>
        <b>{t('TruckOrganization')}</b>
        <br/>
        <br/>
        {t('TruckText')}
        <br /> 
        <br/>
        <b>{t('TruckSphere')}</b>
        <br/>
        <br/>
        <ul>
            <li>
            {t('TruckSphere1')}
            </li>
            <li>
            {t('TruckSphere2')}
            </li>
            <li>
            {t('TruckSphere3')}
            </li>
            <li>
            {t('TruckSphere4')}
            </li>
            <li>
            {t('TruckSphere5')}
            </li>
            <li>
            {t('TruckSphere6')}
            </li>
            <li>
            {t('TruckSphere7')}
            </li>
            <li>
            {t('TruckSphere8')}
            </li>
        </ul>
        <br/>
        <b>  {t('TruckTypes')} </b>
        </MainText>
        <Row>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck1} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType1')}
                </Media>
                {t('TruckType1Text')} 
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck2} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType2')}
                </Media>
                {t('TruckType2Text')}      
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck3} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType3')}
                </Media>
                {t('TruckType3Text')}
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck4} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType4')}
                </Media>
                {t('TruckType4Text')}     
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck5} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType5')}
                </Media>
                {t('TruckType5Text')}   
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck6} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType6')}
                </Media>
                {t('TruckType6Text')}    
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck7} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType7')}
                </Media>
                {t('TruckType7Text')}
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck8} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType8')} 
                </Media>
                {t('TruckType8Text')}
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck9} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType9')}
                </Media>
            </MediaStyled>
        </Media>
        <br />
        <Media>
            <Media left href="#">
            <TrucksImage src={truck10} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType10')}
                </Media>
                {t('TruckType10Text')}
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck11} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType11')}
                </Media>
            </MediaStyled>
        </Media>
        <Media>
            <Media left href="#">
            <TrucksImage src={truck12} alt='logistics'/>
            </Media>
            <MediaStyled body>
                <Media heading>
                {t('TruckType12')}
                </Media>
                {t('TruckType12Text')}      
            </MediaStyled>
        </Media>
        </Row>
      </Row>
      <DemoFooter />
      </Container>
    </>
  );
}

export default ProfilePage;
